import styled from 'styled-components';
import FONTS from '../../../constants/fonts';

export const SandboxContainer = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  box-sizing: border-box;
`;

export const TitleText = styled.h1`
  font-weight: 500;
  font-size: ${FONTS.H3};
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 24px;
  flex-grow: 1;
  padding-top: 16px;
`;

export const TextGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Code = styled.code`
  border: 1px solid #d9d9d9;
  background-color: #f4f4f4;
  border-radius: 6px;
  padding: 2px 4px;
  line-height: 1.8;
`;

export const ErrorCode = styled.div`
  padding-top: 8px;
  border-top: 1px solid #d9d9d9;
  font-size: 14px;
  font-family: Inter;
  width: 100%;
  margin-top: 16px;
`;
